import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import api from "@/utils/api";
import { toast } from "sonner";

const C = {
  h1: (p) => <h2 className="mt-5 mb-2 font-heading text-xl font-bold text-slate-900" {...p} />,
  h2: (p) => <h3 className="mt-5 mb-1.5 font-heading text-base font-semibold text-slate-900" {...p} />,
  h3: (p) => <h4 className="mt-4 mb-1 font-heading text-sm font-semibold text-slate-900" {...p} />,
  p: (p) => <p className="my-2 text-sm leading-relaxed text-slate-700" {...p} />,
  ul: (p) => <ul className="my-2 ml-5 list-disc space-y-0.5 text-sm text-slate-700" {...p} />,
  ol: (p) => <ol className="my-2 ml-5 list-decimal space-y-0.5 text-sm text-slate-700" {...p} />,
  table: (p) => <div className="my-3 overflow-x-auto"><table className="w-full border-collapse text-xs" {...p} /></div>,
  th: (p) => <th className="border border-slate-200 bg-slate-50 px-2 py-1 text-left font-semibold" {...p} />,
  td: (p) => <td className="border border-slate-200 px-2 py-1 align-top" {...p} />,
  strong: (p) => <strong className="font-semibold text-slate-900" {...p} />,
};

export const GovMarkdown = ({ children }) => <ReactMarkdown remarkPlugins={[remarkGfm]} components={C}>{children || ""}</ReactMarkdown>;

export const downloadFile = async (url, fallbackName) => {
  try {
    const res = await api.get(url, { responseType: "blob" });
    const cd = res.headers["content-disposition"] || "";
    const name = (cd.match(/filename="?([^"]+)"?/) || [])[1] || fallbackName;
    const href = URL.createObjectURL(res.data);
    Object.assign(document.createElement("a"), { href, download: name }).click();
    URL.revokeObjectURL(href);
  } catch { toast.error("Download failed"); }
};

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  in_review: "bg-amber-100 text-amber-800 border-amber-200",
  approved: "bg-sky-100 text-sky-700 border-sky-200",
  published: "bg-emerald-100 text-emerald-700 border-emerald-200",
  superseded: "bg-slate-100 text-slate-400 border-slate-200",
  withdrawn: "bg-red-100 text-red-700 border-red-200",
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  terminated: "bg-red-100 text-red-700 border-red-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
};

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "—");
